import { icon } from './icon.js';
import { markText } from './mark-text.js';
import { markWrapper } from './mark-wrapper.js';

function mark(mark, classes, style, on, closeClasses, closeOn) {
  return markWrapper(icon(null, closeClasses, undefined, closeOn), markText(mark), classes, style, on);
}

export { mark };
//# sourceMappingURL=mark.js.map
